module.exports = __webpack_public_path__ + "static/zwyzka-teleskopowa-wycinka-drzew-ffaf43c7af5e639d972b9880d38642b9.jpg";